export const handleToolNavigateToPage = (functionParams, extraParams) => {
    const { route } = functionParams;
    const { navigate, location } = extraParams;

    const state = { ...functionParams };
    delete state.route;

    // check if user is already at the route
    if (location.pathname === route) {
        // retrieve current states
        const currentStates = location.state;

        // Merge location states with new states
        const mergedBrands = [...(currentStates?.brands || []), ...(state?.brands || [])];
        const mergedColors = [...(currentStates?.colors || []), ...(state?.colors || [])];
        const mergedProductTypes = [...(currentStates?.product_types || []), ...(state?.product_types || [])];
        const mergedPostsOrProducts = [...(currentStates?.posts_or_products || []), ...(state?.posts_or_products || [])];

        const mergedStates = {
            ...currentStates,
            ...state,
            brands: mergedBrands,
            colors: mergedColors,
            product_types: mergedProductTypes,
            posts_or_products: mergedPostsOrProducts
        };

        console.log("Merged States: ", mergedStates);
        const bypassAiResponse = "Updating your current view with the new filters.";
        navigate(route, { state: mergedStates });
        return bypassAiResponse;
    } else {
        //console.log("Navigating with state: ", state);
        navigate(route, { state });
        return;
    }
};

export const handleToolTakePhoto = (functionParams, extraParams) => {
    const { setShowTakePhotoPopup, setUserInputText } = extraParams;
    setShowTakePhotoPopup(true);
    setUserInputText("");
    //throw new Error("handleToolTakePhoto not implemented yet");
};

export const handleToolFetchPhotoFromGallery = (functionParams, extraParams) => {
    const { handleUploadClick, setUserInputText } = extraParams;
    console.log("Fetch photo from gallery trigger phrase detected, opening file upload...");
    handleUploadClick();
    setUserInputText("");
    //throw new Error("handleToolFetchPhotoFromGallery not implemented yet");
};

export const handleToolOpenBOtag = (functionParams, extraParams) => {
    const { setUserInputText, appContext, setSelectedBotag, setAiOpenBOtag } = extraParams;
    const { BOTagsList, primaryImageData } = appContext;

    var tag = BOTagsList[0];
    const result = primaryImageData?.find(item => item?.number === tag?.number);
    tag.image = result?.image;
    tag.images = result?.images;

    localStorage.setItem("isBotagOpen", true);
    if (tag?.stockData) {
        const updatedData = tag.stockData.map(item => {
            const { barcode, ...rest } = item; // Extract 'barcode' and keep the rest
            return { GTINbarcode: barcode, ...rest }; // Rename 'barcode' to 'GTINbarcode'
        });
        tag.stockData = updatedData;
    }
    setSelectedBotag(tag);
    setUserInputText("");
    setAiOpenBOtag(true);
};

export const handleToolSelectColor = (functionParams, extraParams) => {
    const { color } = functionParams;
    const { setAiSelectedNewColor /*, stockData, selectedNewSize, setShowNotFoundMsg, setNotFoundMsg*/ } = extraParams;

    console.log("Selected color:", color);
    setAiSelectedNewColor(color);
};

export const handleToolSelectSize = (functionParams, extraParams) => {
    const { size } = functionParams;
    const { setAiSelectedNewSize /*, stockData, selectedNewColor, setShowNotFoundMsg, setNotFoundMsg*/ } = extraParams;

    console.log("Selected size:", size);
    setAiSelectedNewSize(size);
    /*if (!sizeHasStock(size)) {
        setShowNotFoundMsg(true);
        //setNotFoundMsg(`Size ${size} is not in stock in any color`);
        setNotFoundMsg("This size is not in stock in any color");
    } else {
        setShowNotFoundMsg(false);
        setNotFoundMsg("");
        if (!checkSizeAndColor(stockData, size, aiSelectedNewColor)) {
            setShowNotFoundMsg(true);
            //setNotFoundMsg(`Size ${size} is not in stock in selected color`);
            setNotFoundMsg("This is not in stock in this color");
        }
    }*/
};

export const handleToolSelectDeliveryPreferences = (functionParams, extraParams) => {
    const { preference } = functionParams;
    const { setDeliveryPreference /*, setShowNotFoundMsg, setNotFoundMsg*/ } = extraParams;

    console.log("Selected delivery preference:", preference);
    setDeliveryPreference(preference);
};

export const handleToolSelectDeliveryMethod = (functionParams, extraParams) => {
    const { method } = functionParams;
    const { setAiSelectedNewDeliveryMethod /*, setShowNotFoundMsg, setNotFoundMsg*/ } = extraParams;

    console.log("Selected delivery method:", method);
    setAiSelectedNewDeliveryMethod(method);
};

export const handleToolPurchaseWhatsOnBOtag = (functionParams, extraParams) => {
    const { setShouldStartBuyProduct, setUserInputText } = extraParams;
    setShouldStartBuyProduct(true);
    setUserInputText("");
    //throw new Error("handleToolPurchaseWhatsOnBOtag not implemented yet");
};

export const handleToolSearchFiltersWithChatGPT = (functionParams, extraParams) => {
    //throw new Error("handleToolSearchFiltersWithChatGPT not implemented yet");
};

export const handleToolAIfindImageMatch = (functionParams, extraParams) => {
    //throw new Error("handleToolAIfindImageMatch not implemented yet");
};
